import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "languageSelectModal",
  tabindex: "-1",
  "aria-labelledby": "#languageSelectModal"
}
const _hoisted_2 = { class: "modal-dialog modal-sm" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id", "value"]

import { useLang, change } from '@/model/components/header/headerLang'
import { useStore } from '@/store'
import * as log from '@/model/util/log/Logger'

// 状態

export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeaderLang',
  setup(__props) {

const store = useStore()
const state = useLang(store)

// 言語切り替え
const onChange = () => {
  log.trace(`TheHeaderLang onChange start.`)
  change(state, store)
  log.trace(`TheHeaderLang onChange end.`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).list, (option, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "form-check"
            }, [
              _createElementVNode("label", {
                for: option.id,
                class: "form-check-label",
                "data-test": "lang_label"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-check-input",
                  name: "language",
                  id: option.id,
                  value: option.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).lang) = $event)),
                  onChange: onChange,
                  "data-test": "lang_item"
                }, null, 40, _hoisted_6), [
                  [_vModelRadio, _unref(state).lang]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(option.labelKey)), 1)
              ], 8, _hoisted_5)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})